import { Button, CircularProgress } from "@mui/material"
import { FormBottomButtonsWrapper, ProgressWrapper } from "components/common-styles"
import { FileDownload } from "@mui/icons-material"

const CommonFormActions = ({ openPaperwork, isSubmitting, handleClose, handleSubmit, printDocument }) => {
  return (
    <FormBottomButtonsWrapper>
      <Button id="btnCancel" color="info" variant="outlined" disabled={isSubmitting} onClick={handleClose}>
        {"Cancel"}
      </Button>
      {isSubmitting ? (
        <ProgressWrapper>
          <CircularProgress size={32} />
        </ProgressWrapper>
      ) : openPaperwork ? (
        <Button id="btnDownload" variant="contained" onClick={printDocument} startIcon={<FileDownload />}>
          {"Download Paperwork"}
        </Button>
      ) : (
        <Button id="btnSubmit" variant="contained" onClick={handleSubmit}>
          {"Submit"}
        </Button>
      )}
    </FormBottomButtonsWrapper>
  )
}

export default CommonFormActions
